export default __webpack_public_path__ + "static/media/blush_side_logo.fab402fe.svg";